<script lang="ts" setup>
import { computed, type Component } from 'vue'
interface Props {
  is?: string | Component
  reversed?: boolean
  fitContent?: boolean
  valign?: 'top' | 'bottom' | 'center' | undefined
  spacing?: 'cosy' | 'natural' | 'spacious' | undefined
}

const props = withDefaults(defineProps<Props>(), {
  is: 'div',
  valign: undefined,
  spacing: undefined
})

const classes = computed(() => {
  const classArray = ['']
  if (props.reversed) classArray.push('media--reversed')
  if (props.fitContent) classArray.push('media--fit-content')
  if (props.valign) classArray.push(`media--valign-${props.valign}`)
  if (props.spacing) classArray.push(`media--spacing-${props.spacing}`)

  return classArray.join(' ')
})
</script>

<template>
  <component :is="is" class="media" :class="classes">
    <span class="media__content"><slot name="media-content"></slot></span>
    <span class="media__item"><slot name="media-item"></slot></span>
  </component>
</template>

<style lang="scss" scoped>
.media {
  display: grid;
  grid-template-columns: fit-content(200px) 1fr;
  grid-template-areas: 'item content';
  grid-gap: 0 1rem;
}
.media--reversed {
  grid-template-columns: 1fr fit-content(200px);
  grid-template-areas: 'content item';
}
.media--fit-content {
  width: fit-content;
}
.media--valign-top {
  align-items: start;
}
.media--valign-bottom {
  align-items: end;
}
.media--valign-center {
  align-items: center;
}
.media--spacing-cosy {
  grid-gap: 0 0.5rem;
}
.media--spacing-natural {
  grid-gap: 0 1rem;
}
.media--spacing-spacious {
  grid-gap: 0 2rem;
}
.media__item {
  grid-area: item;
}
.media__content {
  grid-area: content;
}
</style>
